import { render, staticRenderFns } from "./PostsListCardItem.vue?vue&type=template&id=7744b114"
import script from "./PostsListCardItem.vue?vue&type=script&lang=ts"
export * from "./PostsListCardItem.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports